import React from 'react';
export function Footer() {
  return <footer className="bg-black text-zinc-400 py-12 border-t border-violet-900/40" data-id="element-125">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-126">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-127">
          🤝 MEGA PACK EMPRENDEDORA™
        </h4>

        <p className="mb-6 text-sm leading-relaxed" data-id="element-128">
          El sistema N°1 de herramientas listas para usar para emprendedoras
          argentinas que venden por redes sociales. Diseñado para quien quiere
          publicar todos los días, vender por WhatsApp con criterio real y hacer
          crecer su negocio con un sistema que funciona aunque trabaje sola y
          tenga poco tiempo.
          <br data-id="element-129" />
          <strong className="text-zinc-300 mt-2 block" data-id="element-130">
            Porque hacer crecer tu negocio no debería depender de si "te surge
            la inspiración" o de si encontrás un tutorial en YouTube que aplique
            a tu situación específica.
          </strong>
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-131">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-violet-400 transition-colors" data-id="element-132">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-133">·</span>
          <span className="hover:text-violet-400 transition-colors" data-id="element-134">
            📱 @centralpack.ar
          </span>
          <span className="hidden sm:inline" data-id="element-135">·</span>
          <span className="hover:text-violet-400 transition-colors" data-id="element-136">
            🌐 www.emprendedora.shop
          </span>
        </div>

        <div className="text-xs text-zinc-600 border-t border-zinc-800 pt-8 space-y-3" data-id="element-137">
          <p data-id="element-138">
            © MEGA PACK EMPRENDEDORA™ 2025 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-zinc-500" data-id="element-139">
            ⚠️ Aviso: Este es un producto educativo digital. Los resultados
            dependen de la implementación individual de cada emprendedora. El
            conocimiento y las herramientas mejoran la toma de decisiones pero
            los resultados varían según el negocio, el mercado y el nivel de
            aplicación.
          </p>
          <p className="italic text-violet-300/80" data-id="element-140">
            🌸🇦🇷 "La próxima vez que alguien te pregunte por tu producto, vas a
            saber exactamente qué decir y cómo cerrarlo."
          </p>
        </div>
      </div>
    </footer>;
}